import apiClient from '@/api/apiClient.js';

export default {
  namespaced: true,
  state: {
    schema: {},
  },

  getters: {
    schema(state) {
      return state.schema;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.patSignUpSchema();

        const schema = res.data;

        const resCat1 = await apiClient.catBirthSexes();
        const catBirthSexes = resCat1.data.data;
        
        const resCat2 = await apiClient.catYear();
        const catYear = resCat2.data.data;

        schema.schemaForm.group1.schema.birth_sexes_birth_sexes_id.items = catBirthSexes;
        schema.schemaForm.group1.schema.users_birth_date_year.items = catYear;
        
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
